// 部品 ボタン左右均等割り用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';
var RowJustifyButton = function (_a) {
    var children = _a.children;
    return (React.createElement(Row, { className: "row-justify-button" },
        React.createElement(Col, { className: "text-center" }, children)));
};
export default RowJustifyButton;
